import React from 'react';
//material ui components
import { AppBar, IconButton, Toolbar, Typography, CssBaseline, MenuItem } from '@mui/material';
// material ui icons
import MenuIcon from '@mui/icons-material/Menu';
import Gene20Box from '../../../Components/Gene20Box/Gene20Box';
import { toogleMenu } from '../../../redux/reducers/menuSlice';
import { useDispatch } from 'react-redux';
import { drawerWidth } from '../../../utils/constant';
import AppBarContent from './appBarContent';
import { styled } from '@mui/styles';
import Logo from '../../../Assets/Images/MotiLogo2.png';

const StyledItem = styled(MenuItem)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  minWidth: 185,
  '& a': {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  '& span': { marginRight: '10px', color: theme.palette.text.primary },
}));
export default function DashBoardAppBar(props) {
  const dispatch = useDispatch();
  return (
    <div>
      <CssBaseline />
      <AppBar
        position="fixed"
        sx={{
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          ml: { sm: `${drawerWidth}px` },
          backdropFilter: 'blur(10px)',
          // background: trigger ? "transparent" : "blue",
        }}
      >
        <Toolbar>
          <IconButton
            color="primary"
            aria-label="open drawer"
            edge="start"
            onClick={() => dispatch(toogleMenu())}
            sx={{
              mr: 2,
              display: { sm: 'none' },
              borderRadius: '10px',
            }}
          >
            <MenuIcon />
          </IconButton>
          <Gene20Box
            // justifyContent="right"
            align="right"
            sx={{
              alignItems: 'center',
              display: 'flex',
              padding: 0,
              margin: 0,
              width: '100%',
            }}
          >
            <Gene20Box
              component="img"
              src={Logo}
              sx={{ width: { xs: '100%', sm: '20vw' } }}
              height="5vh"
            />
          </Gene20Box>

          <AppBarContent />
        </Toolbar>
      </AppBar>
    </div>
  );
}
